"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.rememberWeAreRedirectingToEpicLogin = rememberWeAreRedirectingToEpicLogin;
exports.recallIfWeRedirectedToEpicLoginAndCompleteLoginIfSo = recallIfWeRedirectedToEpicLoginAndCompleteLoginIfSo;

var _auth = require("../redux/modules/auth");

var _reactRouter = require("react-router");

var _utils = require("./utils");

var _RedirectToExternalSite = require("../utils/RedirectToExternalSite");

var _config = require("../config");

var _config2 = _interopRequireDefault(_config);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var localStorageKey = "epicLoginRedirectTo";
var epicLoginInProgress = false;
var epicLoginPromise = null;

var epicLoginUrl = _config2.default.epicSSOBaseUrl + "/login/index?client_id=" + _config2.default.epicClientID + "&response_type=code";
var epicRegisterUrl = _config2.default.epicSSOBaseUrl + "/register/index?client_id=" + _config2.default.epicClientID + "&response_type=code";

function rememberWeAreRedirectingToEpicLogin(location, redirectTo) {
  return function () {
    var pathname = location.pathname;

    if (pathname === "/login" || pathname === "/login-with-epic") {
      var query = location.query;
      var returnTo = query.returnTo,
          return_to = query.return_to;


      if (returnTo || return_to) {
        localStorage.setItem(localStorageKey, returnTo || return_to);
      } else {
        localStorage.setItem(localStorageKey, "/");
      }
    } else {
      localStorage.setItem(localStorageKey, pathname);
    }
    if (redirectTo == "login") {
      (0, _RedirectToExternalSite.checkRedirectRequired)(epicLoginUrl);
    }
    if (redirectTo == "register") {
      (0, _RedirectToExternalSite.checkRedirectRequired)(epicRegisterUrl);
    }
  };
}

function recallIfWeRedirectedToEpicLoginAndCompleteLoginIfSo(location) {
  return function (dispatch, getState) {
    var code = location && location.query && location.query.code || null;

    // If Epic login is already in progress, return the existing promise
    if (epicLoginInProgress && epicLoginPromise) {
      console.log("Epic login already in progress, returning existing promise");
      return epicLoginPromise;
    }

    var epicLoginRedirectTo = localStorage.getItem(localStorageKey);
    localStorage.removeItem(localStorageKey);

    if (code && epicLoginRedirectTo) {
      console.log("Starting Epic login process with code");
      epicLoginInProgress = true;

      epicLoginPromise = dispatch((0, _auth.epicLogin)(code)).then(function (res) {
        if (window) {
          var quixelLogin = window.localStorage.getItem("quixelLogin");
          if (quixelLogin === "true") {
            window.localStorage.setItem("quixelLogin", false);
          }
        }
        if (res.isUnlinkedAccount === true) {
          _reactRouter.browserHistory.push({
            pathname: "/link-epic-account",
            search: "?returnTo=" + epicLoginRedirectTo
          });
        } else {
          return dispatch((0, _auth.validateEula)()).then(function (eulaRes) {
            var newState = getState();
            var user = newState.user;


            var haveEulaAccepted = !eulaRes.hasOwnProperty("version");

            var subscription = user.subscription;

            var doesntAlreadyHaveUnrealUnlimited = !subscription || !subscription.planId === "unreal-unlimited";

            if (haveEulaAccepted && doesntAlreadyHaveUnrealUnlimited) {
              _reactRouter.browserHistory.replace({
                pathname: "/epic-migration",
                search: "?returnTo=" + epicLoginRedirectTo
              });
            } else {
              if (epicLoginRedirectTo === "/epic-migration") {
                _reactRouter.browserHistory.replace(epicLoginRedirectTo, {
                  state: { hideSwitchingPlans: true }
                });
              } else {
                if ((0, _utils.isForumLink)(epicLoginRedirectTo)) {
                  // handling if its external forum link
                  _reactRouter.browserHistory.push({
                    pathname: "/login",
                    search: "?return_to=" + epicLoginRedirectTo
                  });
                } else if (epicLoginRedirectTo.indexOf("/megascans/") > -1) {
                  (0, _RedirectToExternalSite.checkRedirectRequired)(epicLoginRedirectTo);
                } else {
                  _reactRouter.browserHistory.replace(epicLoginRedirectTo);
                }
              }
            }
          });
        }
      }).catch(function (err) {
        // TODO development log only
        console.log("error logging in", err);
        // handle error
        dispatch((0, _auth.loginError)(err));
      }).finally(function () {
        // Reset the flag and promise after completion
        console.log("Epic login process completed");
        epicLoginInProgress = false;
        epicLoginPromise = null;
      });

      return epicLoginPromise;
    }
  };
}


//////////////////
// WEBPACK FOOTER
// ./src/EpicMigration/actions.js
// module id = 436
// module chunks = 0